import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { PetService } from '../../../services/pet.service';
import { MONITOR_ANES, MONITOR_BREATH, MONITOR_FLUIDS, HYDRATION, LUNG_SOUNDS, HEARTH_SOUNDS, PULSE_QUALITY, MM_COLOR, CRT, SUTURE, SUTURE_OTHER, TOOTH } from '../../../../environments/environment';
import { DentalProblemModel } from '../../../models/dental-problem.model';
import Swal from 'sweetalert2';
import { CatalogService } from '../../../services/catalog.service';
import { SharedService } from '../../../services/shared.service';
import { PetEnvironmentModel } from '../../../models/pet-enviroment.model';
import { CodesFileModel } from '../../../models/codes-file.model';
import { PetNoteModel,NoteModel } from '../../../models/pet-note.model';

declare var $: any;

@Component({
  selector: 'ngx-profile-proc',
  templateUrl: './profile-proc.component.html', 
  styleUrls: ['./profile-proc.component.scss']
})
export class ProfileProcComponent implements OnInit {
  private _pet_no: number;
  MONITOR_ANES = MONITOR_ANES;
  MONITOR_FLUIDS = MONITOR_FLUIDS;
  MONITOR_BREATH = MONITOR_BREATH;
  HYDRATION = HYDRATION;
  LUNG_SOUNDS = LUNG_SOUNDS;
  HEARTH_SOUNDS = HEARTH_SOUNDS;
  PULSE_QUALITY = PULSE_QUALITY;
  MM_COLOR = MM_COLOR;
  CRT = CRT;
  SUTURE = SUTURE;
  SUTURE_OTHER = SUTURE_OTHER;
  TOOTH = TOOTH;

  all_codes: CodesFileModel[] = [];

  vitalsigntype = 'vitalsign';
  pr_procedure = ''
  pr_procedurenote = ''

  txtchar: string = '';

  procedure_list: {procedure:string, code_type:string, note:string}[] = [];  
  procedure_details: {procedure: string, code_type: string, note: string} = {procedure: '', code_type: '', note: ''};
  exam_note: string = '';
  exam_note_type: string = '';

  @Input() set pet_no(value: number) {
    this._pet_no = value;
    this.petService.getMetabolicByPetId(this.petService.current_pet_no).then(() => { });
  }

  get pet_no(): number {
    return this._pet_no;
  }


  constructor(
    public petService: PetService,
    public catalogService: CatalogService,
    public sharedService: SharedService,
    private route: ActivatedRoute
  ) {
  }
  

  ngOnInit(): void {
    this.catalogService.getCodesFile(true, this.petService.userData.clinic_no).then(() => {
        this.all_codes = this.catalogService.codes_file  
    });
  }

  save() {
     this.petService.pet_vitals.tag0 = this.pr_procedure + ' (' + this.pr_procedurenote + ')';
     this.petService.setupPetVitals()
          .then(() => {
              
                Swal.close();
    
                Swal.fire({
                  title: 'Information stored correctly',
                  didOpen: () => {
                  }, 
              });
    });
  }
  
  filterCatalog(start: number, end: number): DentalProblemModel[] {
    return this.catalogService.dental_problem.filter(t => t.problem_index >= start && t.problem_index <= end);
  }

  addProcedure() {
    //this.procedure_list.push({procedure: this.procedure_details.procedure, code_type: this.procedure_details.code_type, note: this.procedure_details.note});
 
    let notetype_array = [42];
     

    let txtnote = 'Items Added in Vital Sign Page(Procedure Tab) :\n' +
                  'Procedure:    ' + this.filterText + '\n' +
                  'Code Type:    ' + this.txtchar + '\n' +
                  'Note:        ' + this.procedure_details.note +  
                  ' -- ' + this.petService.userData.employee_name;
 
    this.petService.note = new NoteModel(0, this.pet_no, '','', txtnote, notetype_array); 
    this.petService.setupNote();
    
    this.petService.triggerProcedure(this.filterText, this.txtchar);
  }

  setType(type: string) {
    this.exam_note_type = type; 
  }

  //#region from EXAM NOTE PAGE

  saveExamNote(){
    let notetype_array = []
    let txtnote =   this.exam_note + ' -- ' + this.petService.userData.employee_name;
    if(this.exam_note_type != '' && this.exam_note != '') {  
      if(this.exam_note_type == 'Med'){
        notetype_array.push(2);
      }
      else if(this.exam_note_type == 'Disch'){
        notetype_array.push(7);
      }
      else if(this.exam_note_type == 'Recp'){
        notetype_array.push(8);
      }
      else if(this.exam_note_type == 'Hosp'){
        notetype_array.push(1);
      } 
    }
    else{
      Swal.fire({ 
        title: 'Note Type and Content is Required'
      });

      return false
    }


    this.petService.note = new NoteModel(0, this.pet_no, '','', txtnote, notetype_array); 
    this.petService.setupNote().then(()=>{
        Swal.fire({title: 'Saved Successfully'})
        this.petService.note = new NoteModel(0,0,'','','',[])
    })
  }

  //#endregion


  //#region from PROCEDURE PAGE
  suggestedWordsArray: CodesFileModel[] = [];
  codes_file: CodesFileModel[] = [];
  buscador_activo = false;
  buscador_activo_status = false;
  filterText: string;
  

  search(event: any) {
    this.txtchar = '';
    
    setTimeout(() => {
          this.petService.pet_proc.code_name = event.target.value;

          if (event.key === 'Backspace' || event.key === 'Delete') {
              this.suggestedWordsArray = [];
              this.buscador_activo = false;
          }

          if (this.petService.pet_proc.code_name.length > 2) {
              this.suggestedWordsArray = [];
              this.suggestedWordsArray.push(...this.filterArray(this.catalogService.codes_file, this.petService.pet_proc.code_name.toLowerCase().normalize("NFD").replace(/[\u0300\u0301]/g, ""), 'code_name'));
              this.suggestedWordsArray.push(...this.filterArray(this.catalogService.codes_file, this.petService.pet_proc.code_name.toLowerCase().normalize("NFD").replace(/[\u0300\u0301]/g, ""), 'code_category'));
              this.suggestedWordsArray.push(...this.filterArray(this.catalogService.codes_file, this.petService.pet_proc.code_name.toLowerCase().normalize("NFD").replace(/[\u0300\u0301]/g, ""), 'code_sub_category'));
              this.suggestedWordsArray.push(...this.filterArray(this.catalogService.codes_file, this.petService.pet_proc.code_name.toLowerCase().normalize("NFD").replace(/[\u0300\u0301]/g, ""), 'procedure_desc'));

              if (this.catalogService.codes_vendor.some(t => t.vendor.toLowerCase().normalize("NFD").replace(/[\u0300\u0301]/g, "").includes(this.petService.pet_proc.code_name.toLowerCase().normalize("NFD").replace(/[\u0300\u0301]/g, "")))) {
                  var vendor = this.catalogService.codes_vendor.find(t => t.vendor.toLowerCase().normalize("NFD").replace(/[\u0300\u0301]/g, "").includes(this.petService.pet_proc.code_name.toLowerCase().normalize("NFD").replace(/[\u0300\u0301]/g, "")));
                  this.suggestedWordsArray.push(...this.codes_file.filter(t => vendor.codes.some(v => v == t.code_no)));
              }

              this.buscador_activo = this.suggestedWordsArray.length > 0;
          } else {
              this.suggestedWordsArray = [];
              this.buscador_activo = this.suggestedWordsArray.length > 0;
          }
      }, 100);
  }

  filterArray(array: CodesFileModel[], item: string, field: string) {
    return array
        .filter((word: CodesFileModel) => this.compareTwoStrings(word[`${field}`].normalize("NFD").replace(/[\u0300\u0301]/g, ""), item))
        .sort((a: CodesFileModel, b: CodesFileModel) => {
            if (a[`${field}`].toLowerCase() < b[`${field}`].toLowerCase()) {
                return -1;
            }
            if (a[`${field}`].toLowerCase() > b[`${field}`].toLowerCase()) {
                return 1;
            }
            return 0;
        });
  }

  compareTwoStrings(string: any, subString: any) {
      if (string.toLowerCase().normalize("NFD").replace(/[\u0300\u0301]/g, "").includes(subString)) return subString;
  }

  select(item: CodesFileModel) {
      this.filterText = item.code_name;
      this.petService.pet_proc.code_no = item.code_no;
      this.petService.pet_proc.code_type = item.code_type;
      this.petService.pet_proc.code_name = item.code_name;
      this.petService.pet_proc.procedure_desc = item.procedure_desc;
      this.suggestedWordsArray = [];
      this.buscador_activo = this.suggestedWordsArray.length > 0;
      this.buscador_activo_status = true;
      //  debugger;
  } 
  //#endregion


}
